import React from 'react'
export default function About() {
  return (
    
    <div className='about' style={{textAlign:"center"}}>
        <h1>About Me</h1>
        <p style={{"text-align":"justify"}}>
        Hello! I'm a dedicated Software Engineer currently working at Crest Data Systems, in Ahemdabad, India. where I contribute my expertise to building robust and innovative software solutions. I am a proud graduate from IIIT Surat with a specialization in Computer Science and Engineering, class of '24.
        </p>
  
        <p style={{"text-align":"justify"}}>
        Driven by my passion for problem-solving, I have honed my skills through extensive practice, solving over 600 problems on GeeksforGeeks and 250+ on LeetCode, achieving a commendable ranking of 1688 on LeetCode. This journey has equipped me with a deep understanding of algorithms, data structures, and efficient coding practices.
        </p>
        <p style={{"text-align":"justify"}}>
        During my academic journey, I maintained an exceptional academic record, securing an impressive 8.8 CGPA. Alongside my coursework, I actively engaged in various projects and extracurricular activities to broaden my skill set and knowledge base.
        </p>
        <p style={{"text-align":"justify"}}>
        One of my notable projects is "leafLine," a MERN-based e-commerce website specializing in the sale of plants. This project allowed me to apply my expertise in full-stack development, leveraging technologies like MongoDB, Express.js, React.js, and Node.js to create a seamless and user-friendly platform for plant enthusiasts.
        </p>
        <p style={{"text-align":"justify"}}>
        With a solid foundation in software engineering principles, coupled with a proactive approach to learning and problem-solving, I am committed to making meaningful contributions to the field of technology and driving innovation forward.
        </p>
        <p style={{"text-align":"justify", marginTop:"20%"}}>
        </p>
    </div>
  )
}
